import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

export enum PLATFORM_FEATURE_FLAGS {
  LOCAL_GROUP_FILTER_PHX_IMPLEMENTATION_ENABLED = 'local-group-filter-phx-implementation-enabled',
  MINIMUM_BROWSER_CHECK_ENABLED = 'minimum_browser_check_enabled',
  FE_FV_TYPEAHEAD_ENABLED = 'fe-typeahead-enabled',
  FE_CARDS_TYPEAHEAD_ENABLED = 'fe-cards-typeahead-enabled',
  ENTITY_TYPESAHEAD_ENABLED = 'entity-typeahead-search-enabled',
  BULK_API_ON_APPLOAD_ENABLED = 'bulk-api-on-appload-enabled',
  FP_PERSONA_SURVEY_ENABLED = 'fp-persona-survey-enabled',
  FP_FILTERS_PERSISTENCE_ENABLED = 'fe-platform-filters-persistence-enabled',
  FP_GROUP_HEADER_ENABLED = 'fp-group-header-enabled',
  FP_SIDEBAR_COLLAPSIBLE_ENABLED = 'fp-sidebar-collapsible-enabled',
  FP_ADMIN_SWITCHER_ENABLED = 'fp-admin-switcher-enabled',
  PHX_MORE_FILTER_ENABLED = 'phx-more-filter-enabled',
}

@Injectable({ providedIn: 'root' })
export class PlatformFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isLocalGroupFilterPhxImplementationEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.LOCAL_GROUP_FILTER_PHX_IMPLEMENTATION_ENABLED);
  }

  public isMinimumBrowserCheckEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.MINIMUM_BROWSER_CHECK_ENABLED);
  }

  public isFETypeaheadEnabled(): boolean {
    return this.statsigService
      .evaluateGate(PLATFORM_FEATURE_FLAGS.FE_FV_TYPEAHEAD_ENABLED);
  }

  public isFECardsTypeaheadEnabled(): boolean {
    return this.statsigService
      .evaluateGate(PLATFORM_FEATURE_FLAGS.FE_CARDS_TYPEAHEAD_ENABLED);
  }

  public isAppLoadBulkAPIEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.BULK_API_ON_APPLOAD_ENABLED);
  }

  public isPersonaSurveyEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_PERSONA_SURVEY_ENABLED);
  }

  public isEntityTypeaheadEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.ENTITY_TYPESAHEAD_ENABLED);
  }

  public isAdminGroupHeaderEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_GROUP_HEADER_ENABLED);
  }

  public isFiltersPersistenceEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_FILTERS_PERSISTENCE_ENABLED);
  }

  public isSidebarCollapsibleEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_SIDEBAR_COLLAPSIBLE_ENABLED);
  }

  public isAdminSwitcherEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_ADMIN_SWITCHER_ENABLED);
  }

  public isPhxMoreFilterEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.PHX_MORE_FILTER_ENABLED);
  }
}
